import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { CircularProgress, Box } from '@mui/material';

const SmartRedirect: React.FC = () => {
  const user = useSelector((state: RootState) => state.auth.user);

  // If user data is still loading, show a spinner
  if (!user) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // For dual-role users, respect the login_mode to determine which dashboard to show
  // This allows club managers who are also pilots to see the pilot dashboard
  // when they log in via the pilot login form
  if (user.login_mode === 'pilot' && user.is_pilot) {
    return <Navigate to="/app/pilot-dashboard" replace />;
  }

  // Default hierarchy: admin/club_manager -> dashboard, pilot -> pilot-dashboard
  if (user.user_type === 'club_manager' || user.is_platform_admin === true) {
    return <Navigate to="/app/dashboard" replace />;
  }

  // Default: pilots and other users go to pilot dashboard
  return <Navigate to="/app/pilot-dashboard" replace />;
};

export default SmartRedirect;